export const CATEGORIES = [
  "Global Arbitration News", "India Arbitration & ODR", "Institutional Updates",
  "ICC Arbitration", "ICSID Arbitration", "UNCITRAL Updates",
  "Award Enforcement", "Set Aside and Annulment", "Commercial Arbitration",
  "Investor-State Arbitration", "AI in Arbitration", "Digital Hearings",
  "Weekly Arbitration Digest", "Arbitration Explainers",
];

export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 70);

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric", month: "long", year: "numeric",
    });
  } catch {
    return "";
  }
};

export const fmtRelative = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(iso);
};
